// extracted by mini-css-extract-plugin
export default {"irrelevantAnswerContainer":"IrrelevantAnswerContainer_irrelevantAnswerContainer__Lrhxf","fadeIn":"IrrelevantAnswerContainer_fadeIn__0XqsY"};